import axiosInstance from '../axiosInstance';

// 어드민 약관·개인정보처리방침 개정 안내 메일 API
const QUIET = { skipLoading: true, skipGlobalError: true };

export const getPolicyNoticeStatus = async (campaignKey, audience) => {
  const response = await axiosInstance.get('/admin/policy-notice/status', {
    params: { campaignKey, audience },
    ...QUIET,
  });
  return response.data.data;
};

export const previewPolicyNotice = async (payload) => {
  const response = await axiosInstance.post(
    '/admin/policy-notice/preview',
    payload,
    QUIET,
  );
  return response.data.data;
};

export const sendPolicyNoticeTest = async (payload) => {
  const response = await axiosInstance.post(
    '/admin/policy-notice/test-send',
    payload,
    QUIET,
  );
  return response.data.data;
};

export const sendPolicyNotice = async (payload) => {
  const response = await axiosInstance.post(
    '/admin/policy-notice/send',
    payload,
    QUIET,
  );
  return response.data.data;
};
